import { IconProps } from "../../types/utils";

const VerifiedIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill={color || "#3C93FB"} />
    <path d="M18 7.19995L9.75 16.8L6 12.4363" fill={color || "#3C93FB"} />
    <path
      d="M18 7.19995L9.75 16.8L6 12.4363"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VerifiedIcon;
